// ============================================
// API SERVICE
// ============================================

import { createApiClient, ApiClient } from '@crew-at-sea/api-client';
import { useAuthStore } from '@/store/auth';

let apiClient: ApiClient | null = null;

export function initializeApiClient(): void {
  apiClient = createApiClient({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1',
    timeout: 10000,
    
    getAccessToken: () => {
      return useAuthStore.getState().accessToken;
    },
    
    getRefreshToken: () => {
      return useAuthStore.getState().refreshToken;
    },
    
    onAccessTokenRefreshed: (accessToken, refreshToken) => {
      useAuthStore.getState().setTokens(accessToken, refreshToken);
    },
    
    onUnauthorized: () => {
      useAuthStore.getState().logout();
      window.location.href = '/login';
    },
    
    onError: (error) => {
      console.error('API Error:', error);
    },
  });
}

export function getApi(): ApiClient {
  if (!apiClient) {
    initializeApiClient();
  }
  return apiClient!;
}

// Re-export API endpoints
export {
  authApi,
  usersApi,
  companiesApi,
  jobsApi,
  applicationsApi,
  reviewsApi,
  certificatesApi,
  adminApi,
} from '@crew-at-sea/api-client';
